export const SHOW_GENERIC_MESSAGE = 'app:SHOW_GENERIC_MESSAGE'
export const HIDE_GENERIC_MESSAGE = 'app:HIDE_GENERIC_MESSAGE'

export const SET_URL_REDIRECT = 'auth:SET_URL_REDIRECT'
